module.exports = __webpack_public_path__ + "media/Perfect - Ed Sheeran.c6f48a26.mp3";